import { render } from "./GoogleDelete.vue?vue&type=template&id=3d4820e4&scoped=true"
import script from "./GoogleDelete.vue?vue&type=script&lang=js"
export * from "./GoogleDelete.vue?vue&type=script&lang=js"

import "./GoogleDelete.vue?vue&type=style&index=0&id=3d4820e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4820e4"]])

export default __exports__